"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 2v20l4-4h16V2zm15 11-2-1.99V14H7V6h8v2.99L17 7z"
}), 'VideoChatSharp');